import { useAuthStore } from '../../store/authStore'
import { useNavigate } from 'react-router-dom'
import { UserX, ArrowLeft } from 'lucide-react'

export default function ImpersonationBanner() {
  const { isImpersonating, user, originalUser, exitImpersonation } = useAuthStore()
  const navigate = useNavigate()

  if (!isImpersonating) return null

  const handleExit = () => {
    exitImpersonation()
    navigate('/superadmin')
  }

  return (
    <div className="bg-yellow-500 text-yellow-900 px-4 py-2">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <UserX className="h-5 w-5" />
          <span className="font-medium">
            Impersonating: {user?.name} ({user?.company?.name})
          </span>
          <span className="text-yellow-700 text-sm">
            — Logged in as {originalUser?.name}
          </span>
        </div>
        <button
          onClick={handleExit}
          className="flex items-center gap-2 bg-yellow-600 hover:bg-yellow-700 text-white px-3 py-1 rounded text-sm font-medium transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Exit Impersonation
        </button>
      </div>
    </div>
  )
}
